goog.provide('el8.appshared.dialog.approveControlledMed');

goog.require('el8.uiwidget.QuickSelectDialog');
goog.require('el8.ptdata.rxRefillRequests');
goog.require('el8.ptdata.medOrders');


el8.appshared.dialog.approveControlledMed = (function() {

    var spec = null;

    var that = new el8.uiwidget.QuickSelectDialog({
        title: 'Refilling a Schedule III-V Controlled Substance',
        msg: 'Authorization of refill requests for Controlled Substances cannot be done electronically. Please choose one of the below options to ensure the pharmacy receives the authorization:',
        callbackFn: function(index) {
            var lookup = [
                function() {
                    el8.ptdata.rxRefillRequests.submitApproval(
                        spec.refill, spec.authRefills, spec.note, spec.noChange,
                        function(newOrder) {
                            el8.ptdata.medOrders.printSingle(newOrder, 'controlled');
                            that.hide();
                        }
                    );
                },
                function() {
                    el8.ptdata.rxRefillRequests.submitApproval(
                        spec.refill, spec.authRefills, spec.note, spec.noChange,
                        function(newOrder) {
                            el8.ptdata.medOrders.printSingle(newOrder, 'prescription', null, true);
                            that.hide();
                        }
                    );
                },
                function() {
                    el8.ptdata.rxRefillRequests.submitApproval(
                        spec.refill, spec.authRefills, spec.note, spec.noChange,
                        function(newOrder) { 
                            el8.ptdata.medOrders.callInSet([newOrder]);
                            that.hide(); 
                        }
                    );
                },
                function() { that.hide(); }
            ];
            return lookup[index] ? lookup[index]() : null;
        },
        list: [
            'Print script on tamper-proof prescription paper to be given to patient',
            'Print script so that it may be faxed to pharmacy',
            '', // Placeholder for "call pharmacy" caption
            'Cancel'
        ]
    });

    function getCallPharmacyCaption(phone, name) {
        return 'Call ' + name + ' directly' + phone;
    }

    var super_show = that.show;
    that.show = function(_spec) {
        spec = _spec || {};
        super_show.call(that);
        var pharmacyPhone = spec.refill && spec.refill.getPharmacyPhone() ? 
            ' at ' + spec.refill.getPharmacyPhone() : '';
        var pharmacyName = spec.refill && spec.refill.getPharmacyName() ? 
            spec.refill.getPharmacyName() : 'the pharmacy';
        that.setItemCaption(2, getCallPharmacyCaption(pharmacyPhone, pharmacyName));
        that.adjustHeight();
    };

    return that;

})();


